export default "__VITE_ASSET__CX3B2pGF__"